class BmQuiz extends HTMLElement {
  connectedCallback() {
    this.answers = {};
    this.steps = this.querySelectorAll('[data-bm-quiz-step]');
    this.result = this.querySelector('[data-bm-quiz-result]');
    this.cards = this.querySelectorAll('[data-bm-quiz-outcome]');

    this.querySelectorAll('[data-bm-quiz-answer]').forEach((btn) => {
      btn.addEventListener('click', () => this.answer(btn.dataset.q, btn.dataset.v));
    });

    const backBtn = this.querySelector('[data-bm-quiz-back]');
    if (backBtn) backBtn.addEventListener('click', () => this.goToStep(1));

    const restartBtn = this.querySelector('[data-bm-quiz-restart]');
    if (restartBtn) restartBtn.addEventListener('click', () => this.restart());
  }

  answer(question, value) {
    this.answers[question] = value;
    if (question === '1') {
      this.goToStep(2);
    } else if (question === '2') {
      this.showResult();
    }
  }

  goToStep(stepNumber) {
    this.steps.forEach((step) => {
      step.hidden = step.dataset.bmQuizStep !== String(stepNumber);
    });
    this.result.hidden = true;
  }

  showResult() {
    this.steps.forEach((step) => { step.hidden = true; });
    const key = `${this.answers['2']}-${this.answers['1']}`;
    this.cards.forEach((card) => {
      card.hidden = card.dataset.bmQuizOutcome !== key;
    });
    this.result.hidden = false;
    this.result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  restart() {
    this.answers = {};
    this.result.hidden = true;
    this.cards.forEach((card) => { card.hidden = true; });
    this.goToStep(1);
  }
}

customElements.define('bm-quiz', BmQuiz);
